import { PUBLIC_ROUTE } from "src/app/constants/route.constants"

export const LOGIN_ROUTE = {
    path:'login',
    get url() {
        return `${PUBLIC_ROUTE.url}/${this.path}`
    }
}